var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#3666EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9276 15.6027H16.9093C16.9745 15.6027 17.0091 15.5293 16.9739 15.479L12.9164 11.4141C12.7612 11.2587 12.6839 11.0552 12.6845 10.8518C12.6845 10.6483 12.7612 10.4443 12.9164 10.2894L16.9768 6.22167C17.0264 6.17197 16.9912 6.08643 16.9208 6.08643H14.9385C14.9045 6.08643 14.8722 6.09799 14.8451 6.11764L12.9845 7.98158C12.2241 8.74334 11.7971 9.77617 11.7971 10.8535C11.7971 11.899 12.2004 12.9018 12.9193 13.6567L14.8162 15.557C14.8456 15.5865 14.886 15.6032 14.9281 15.6032L14.9276 15.6027Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07269 15.6027H5.09095C5.02576 15.6027 4.99114 15.5293 5.02633 15.479L9.08385 11.4141C9.23905 11.2587 9.31636 11.0552 9.31578 10.8518C9.31578 10.6483 9.23905 10.4443 9.08385 10.2894L5.02345 6.22167C4.97383 6.17197 5.00903 6.08643 5.07941 6.08643H7.06173C7.09577 6.08643 7.12808 6.09799 7.15519 6.11764L9.01578 7.98158C9.77617 8.74334 10.2031 9.77617 10.2031 10.8535C10.2031 11.899 9.79982 12.9018 9.08097 13.6567L7.18404 15.557C7.15461 15.5865 7.11423 15.6032 7.07211 15.6032L7.07269 15.6027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymx);
export default __webpack_public_path__ + "static/media/symx.fd4c503ae8ae9d2455da101a19c7cb45.svg";
export { ForwardRef as ReactComponent };